import { TrendingUp, TrendingDown, Wallet, Coins, Users, Truck, Layers3 } from "lucide-react";
import { useCachedResource } from "../hooks/useCachedResource";
import { acctDashboard } from "../api/accounting";
import { AcctShell } from "../features/acct/AcctShell";
import { StatTile } from "../features/acct/StatTile";
import { TrendChart } from "../features/acct/TrendChart";
import { AlertList } from "../features/acct/AlertList";
import { RankList } from "../features/acct/RankList";
import { RecentMovesCard } from "../features/acct/RecentMovesCard";

// لوحة تحكم المحاسبة بأسلوب HELCOO 3D Neu — KPIs ملوّنة، مخطط 12 شهراً، تنبيهات، قوائم مصنّفة.
export default function AcctDashboardPage() {
  const { data } = useCachedResource("acct-dashboard", () => acctDashboard());

  if (!data) return <AcctShell />;
  const profit = Number(data.net_profit);
  const profitTone = profit >= 0 ? "emerald" : "rose";
  const profitIcon = profit >= 0 ? TrendingUp : TrendingDown;

  return (
    <AcctShell>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4" data-testid="acct-kpis">
        <StatTile testId="stat-revenue"  labelKey="acct.report.revenue"
                  value={data.revenue}   tone="sky"     icon={Coins} />
        <StatTile testId="stat-expenses" labelKey="acct.report.operating_expenses"
                  value={data.expenses}  tone="amber"   icon={Wallet} />
        <StatTile testId="stat-net"      labelKey="acct.report.net_profit"
                  value={data.net_profit} tone={profitTone} icon={profitIcon} />
        <StatTile testId="stat-cash"     labelKey="acct.grandTotal"
                  value={data.grand_total} tone="violet" icon={Layers3} />
      </div>

      <AlertList />
      <TrendChart series={data.series} />

      <div className="grid gap-4 lg:grid-cols-3">
        <RankList testid="expense-split" titleKey="acct.expenseSplit"
                  rows={data.expense_split} valueField="amount" nameField="name" />
        <RankList testid="top-suppliers" titleKey="acct.topSuppliers"
                  rows={data.top_suppliers} icon={<Truck className="h-5 w-5 text-primary" />} />
        <RankList testid="top-customers" titleKey="acct.topCustomers"
                  rows={data.top_customers} icon={<Users className="h-5 w-5 text-primary" />} />
      </div>

      <RecentMovesCard moves={data.recent_moves} />
    </AcctShell>
  );
}
